/** A duration, not a time of day. Long routes must not be displayed as thousands of minutes. */
export function itineraryDuration(value: number, language: string): string {
  if (!Number.isFinite(value)) return "—";
  const total = Math.max(0, Math.round(value)), days = Math.floor(total / 1440), hours = Math.floor(total % 1440 / 60), minutes = total % 60;
  const day = language === "en" ? (days === 1 ? "day" : "days") : language === "es" ? (days === 1 ? "día" : "días") : (days === 1 ? "giorno" : "giorni");
  return [days ? `${days} ${day}` : "", hours ? `${hours} h` : "", minutes || !total ? `${minutes} min` : ""].filter(Boolean).join(" ");
}
